 

<!-- <app-charts [chartData]="chartData" [chartContainer]="'payment-status'" [chartOpts]="chartOpts"></app-charts> -->

    <div [attr.id]="chartContainer " style="height:300px;"></div>


